import { AdyenBookingContext } from '@models/adyen.model';
import { AppointmentCartItem, SelectedBookingDataModel } from '@models/selected-booking-data.model';

/**
 * The booking context the backend derives the booked store - and so the Adyen merchant account -
 * from. The availability check (`payment-method-view`) and the session request (`cw-adyen`) must
 * describe the same booking, so both build it here and nowhere else.
 *
 * Only the worker: `/book` sends no store, so the appointment lands in the worker's own store, and
 * that is the store both sides must derive. Fields that name nothing are left out, because the
 * object doubles as a query string.
 */
export function buildAdyenBookingContext(bookingData: SelectedBookingDataModel | undefined): AdyenBookingContext {
  const workerId = bookedWorkerId(bookingData?.cartItems?.[0]);
  return workerId === undefined ? {} : { worker_id: workerId };
}

/**
 * The worker `/book` sends for a cart item - the same rule
 * `BookingSummaryViewComponent.createBookingPayload()` applies: a combi service goes to the first
 * worker of its mapping, anything else to the worker of the chosen slot. With "any worker" or
 * "any store" that slot's worker is the one who gets booked, not the selection.
 */
function bookedWorkerId(item: AppointmentCartItem | undefined): number | undefined {
  const combiWorkerId = item?.service?.is_combi && item.combiServiceWorkersMapping
    ? Object.values(item.combiServiceWorkersMapping)[0]
    : undefined;
  const value = Number(combiWorkerId ?? item?.workerId);
  return Number.isInteger(value) && value > 0 ? value : undefined;
}
